import styled from '@emotion/styled';

export const EditCollectionRulesStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 90px;
`;
